import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'caret-right', 'CaretRight', [["path",{"d":"M10 18l6 -6l-6 -6v12"}]]);